import { View, Image } from '@react-pdf/renderer';
import CompassImage from 'assets/images/iconiq-compass-logo.png';

export const PdfHeader = () => {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        height: '40px',
        padding: '8px 20px',
        backgroundColor: '#F4FBF6'
      }}
    >
      <View style={{ width: '86px' }}>
        <Image src={CompassImage} />
      </View>
    </View>
  );
};
